<template>
	<v-app>
		<v-navigation-drawer id="nav-draw" v-model="drawer" fixed app dark>
			<v-list dense two-line subheader>
				<v-list-tile
					v-for="item in routeItems"
					:key="item.route"
					@click="openPortal(item)"
				>
					<v-list-tile-action>
						<v-icon :color="item.iconColor" medium>{{ item.icon }}</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="subheading">
							<span v-if="item.highlight" :style="getColor(item)">{{
								item.title
							}}</span>
							<span v-else>{{ item.title }}</span>
						</v-list-tile-title>
						<v-list-tile-sub-title></v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-navigation-drawer>
		<v-toolbar color="light-blue darken-3" app>
			<v-toolbar-side-icon
				color="white"
				@click.stop="drawer = !drawer"
			></v-toolbar-side-icon>
			<v-toolbar-title class="font-weight-regular text-uppercase">
				<span class="white--text">{{ title }}</span>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-menu
				id="date-menu"
				ref="menu"
				:close-on-content-click="false"
				v-model="menu"
				:nudge-right="40"
				:return-value.sync="dates"
				lazy
				transition="scale-transition"
				offset-y
				full-width
				min-width="290px"
			>
				<!-- hint="Set validity for the privilege" -->
				<v-combobox
					label="Select Dates"
					slot="activator"
					v-model="dates"
					multiple
					chips
					small-chips
					persistent-hint
					readonly
					color="black darken-3"
					style="margin-top:14px"
				></v-combobox>
				<!-- :min="new Date().toISOString().substr(0, 10)" -->
				<v-date-picker
					color="black darken-2"
					v-model="dates"
					multiple
					no-title
					scrollable
				>
					<v-spacer></v-spacer>
					<v-btn flat color="pink" @click="menu = false">Cancel</v-btn>
					<v-btn flat color="orange darken-1" @click="saveDates">OK</v-btn>
				</v-date-picker>
			</v-menu>
		</v-toolbar>
		<!-- <v-dialog v-model="loaderDialog" persistent max-width="75">
		<div class="spinner-wrapper">
			<v-progress-circular indeterminate color="amber" :size="50" :width="7"></v-progress-circular>
		</div>
		</v-dialog>-->
		<v-dialog v-model="loaderDialog" persistent width="300">
			<v-card color="light-blue darken-4" dark>
				<v-card-text>
					Please stand by {{ userData.name }}
					<v-progress-linear
						indeterminate
						color="white"
						class="mb-0"
					></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-snackbar
			v-model="snackbar"
			left
			:color="snackbarColor"
			:timeout="snackbarTime"
			top
			multi-line
		>
			{{ snackbarText }}
			<!-- <v-btn color="pink" flat @click.stop="closeSnackbar">Close</v-btn> -->
		</v-snackbar>
		<v-content>
			<router-view />
		</v-content>
	</v-app>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapMutations } from 'vuex';
export default {
	name: 'App',
	data() {
		return {
			drawer: null,
			routeItems: [
				{
					icon: 'data_usage',
					title: 'Dashboard',
					route: '/',
					highlight: false,
				},
				// {
				// 	icon: "delete",
				// 	title: "File Meta",
				// 	route: "/file-meta"
				// },
				{
					icon: 'rule_folder',
					title: 'Map Files',
					route: '/file-extraction',
					highlight: '#00a0ff',
					iconColor: '#00a0ff',
				},
				{
					icon: 'file_copy',
					title: 'Extracted Files',
					route: '/extracted-data',
					highlight: false,
				},
				{
					icon: 'repeat',
					title: 'Rework Extracted Files',
					route: '/reword-extracted-data',
					highlight: '#00a0ff',
					iconColor: '#00a0ff',
				},
				{
					icon: 'delete_forever',
					title: 'Rejected Files',
					route: '/rejected-meta',
					highlight: false,
				},
				{
					icon: 'loop',
					title: 'Rework Rejected Files',
					route: '/reject-meta-two',
					highlight: '#00a0ff',
					iconColor: '#00a0ff',
				},
				{
					icon: 'list_alt',
					title: 'Stockist List',
					route: '/stockist-mapping',
					highlight: false,
				},
				{
					icon: 'search',
					title: 'Identify Stockist',
					route: '/identify-stockist',
					highlight: '#00a0ff',
					iconColor: '#00a0ff',
				},
			],
			dates: [],
			menu: false,
			moment: false,
			snackbar: false,
			timeout: 3000,
			title: 'SSE/Dashboard',
		};
	},
	created() {
		this.moment = moment;
	},
	methods: {
		...mapMutations([
			'setSelectedDates',
			'openLoaderDialog',
			'openSnackbar',
			'closeSnackbar',
		]),
		openPortal(item) {
			this.title = this.title.split('/')[0] + '/' + item.title;
			if (item.hasOwnProperty('prop')) {
				this.$router.push({
					name: item.route,
					params: {
						propItem: item.prop,
					},
				});
			} else {
				this.$router.push({
					path: item.route,
				});
			}
		},
		saveDates() {
			// this.dates.splice(2, this.dates.length);
			if (this.dates.length > 0) {
				let d = this.dates.sort(function(a, b) {
					return a < b ? -1 : a > b ? 1 : 0;
				});

				this.dates = [d[0], d[d.length - 1]];

				this.setSelectedDates(Object.assign([], this.dates));
				this.$refs.menu.save(this.dates);
				// console.log(this.getSelectedDates);
			}
		},
		getColor(item) {
			return {
				color: item.highlight,
			};
		},
	},
	computed: {
		...mapGetters([
			'getSelectedDates',
			'loaderDialog',
			'snackbarState',
			'snackbarText',
			'snackbarColor',
			'snackbarTime',
			'startDay',
			'userData',
		]),
	},
	mounted() {
		if (
			Number(
				moment()
					.tz('Asia/Kolkata')
					.format('DD')
			) >= this.startDay
		) {
			this.dates[0] = moment()
				.startOf('month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('YYYY-MM-DD');
			this.dates[1] = moment()
				.startOf('month')
				.add(1, 'month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('YYYY-MM-DD');
		} else {
			this.dates[0] = moment()
				.startOf('month')
				.subtract(1, 'month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('YYYY-MM-DD');
			this.dates[1] = moment()
				.startOf('month')
				.add(this.startDay - 1, 'day')
				.tz('Asia/Kolkata')
				.format('YYYY-MM-DD');
		}
		this.saveDates();

		this.$store.subscribe(mutation => {
			if (mutation.type === 'openSnackbar') {
				this.snackbar = true;
			} else if (mutation.type === 'closeSnackbar') {
				this.snackbar = false;
			}
		});
		// this.openSnackbar({ text: "This is a test please work", time:10000 });
		this.openPortal({
			icon: 'bubble_chart',
			title: 'Dashboard',
			route: '/',
		});
		// this.openPortal({
		// 	icon: "remove",
		// 	title: "Identify Stockist",
		// 	route: "/identify-stockist",
		// 	highlight: false
		// });
	},
};
</script>

<style lang="scss" scoped>
.spinner-wrapper {
	height: 75px;
	overflow: auto;
	display: flex;
	justify-content: center;
	align-items: center;
}

v-dialog {
	box-shadow: none;
}
</style>

<style lang="scss">
#date-menu {
	.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
		border-color: black;
	}

	.mdi-menu-down:before {
		color: black !important;
	}

	.theme--light.v-label {
		color: black !important;
	}

	.v-chip .v-chip__content {
		color: black;
	}
}
// ScrollBar Styles to make it look like macbook (Will only work on modern browsers)
::-webkit-scrollbar {
	width: 8px;
}

::-webkit-scrollbar-track {
	// -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
	border-radius: 10px;
}

::-webkit-scrollbar-thumb {
	background-color: lightgray;
	border-radius: 10px;
	// -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.show-on-parent-hover {
	display: none;
}

.show-on-child-hover {
	display: none;
}

.expansion-panel-parent {
	&:hover {
		.show-on-parent-hover {
			display: unset;
		}
	}
}
.expansion-panel-child {
	&:hover {
		.show-on-child-hover {
			display: unset;
		}
	}
}

.badge-circle {
	height: 12px;
	width: 12px;
	background-color: gold;
	border-radius: 50%;
	margin-left: 6px;

	&.green-badge {
		background-color: green;
	}
}

.toolbar-title-wrapper {
    display: flex;
    justify-content: space-between;
	align-items: center;
	width: 100%;

	.stockiest-name-wrapper {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
}
</style>
